var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notFound"},[_c('div',{staticClass:"notFound__body"},[_c('p',[_vm._v("認証エラーが発生しました")]),_vm._v(" "),_c('Btn',{staticClass:"withdraw",attrs:{"label":'ログイン画面に戻る',"color":'red'},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Login' })}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23aa21da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/errors/401.vue
// module id = null
// module chunks = 